export default __webpack_public_path__ + "static/media/bg-footer-bottom.c477d755.png";